import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumb({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="flex w-full min-w-0 items-center gap-x-1.5 gap-y-0 text-xs font-mono-x text-muted-foreground flex-wrap" data-testid="breadcrumb">
      {items.map((it, i) => (
        <span key={i} className={`flex min-w-0 items-center gap-1.5 ${i === items.length - 1 ? "max-w-full" : "shrink-0"}`}>
          {i > 0 && <ChevronRight className="w-3 h-3" />}
          {it.to ? <Link to={it.to} className="inline-flex min-h-11 items-center hover:text-foreground transition-colors">{it.label}</Link> : <span className="min-w-0 break-words py-3 text-foreground">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
}
